import { useSelector } from 'react-redux';

const usePhotoOptimisticEdits = () => {
  const photosById = useSelector((state) => state.photos.photosById);

  const getOptimisticUri = (photoId) => {
    const photo = photosById[photoId];

    return photo?.optimisticUri;
  };

  return { getOptimisticUri };
};

export default usePhotoOptimisticEdits;
